import { createTheme } from '@mui/material/styles';

// Palette derived directly from the official Taraba State logo:
// vivid Nigerian green (logo ring) with a bronze/gold accent (ring + crest),
// on white. Primary green is slightly deepened so white text meets WCAG AA.
const theme = createTheme({
  palette: {
    primary: { main: '#0C7D38', light: '#2FA85C', dark: '#0A5C2C', contrastText: '#FFFFFF' },
    secondary: { main: '#A07030', dark: '#7C5620', contrastText: '#FFFFFF' },
    success: { main: '#2E7D32' },
    warning: { main: '#ED6C02' },
    error: { main: '#C62828' },
    background: { default: '#F6F7F5', paper: '#FFFFFF' },
    text: { primary: '#1A2421', secondary: '#5B665F' },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.01em' },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: { styleOverrides: { root: { border: '1px solid #E4E8E4' } }, defaultProps: { elevation: 0 } },
    MuiAppBar: { defaultProps: { elevation: 0 } },
  },
});

export default theme;